import React from 'react';
import EmptyState from './empty-state';
import AddToPortfolioCard from './add-to-portfolio-card';
import {linkForCollegeSuccessItem} from '../utils';
import Carousel from 'shared/components/carousel';

interface CarouselDisplayProps {
  collegeSuccessItems: CollegeSuccessItem[];
}

interface CollegeSuccessItem {
  _id: string;
  collegeSuccessItemType: string;
  key: string;
  emoji?: string;
  title: string;
  link: string;
}

const CarouselDisplay = (props: CarouselDisplayProps): React.ReactElement | null => {
  const {collegeSuccessItems} = props;

  return (
    <Carousel>
      {collegeSuccessItems.length === 0 && <EmptyState />}
      {collegeSuccessItems.map((item) => {
        const {emoji, _id, collegeSuccessItemType, title} = item;
        return (
          <AddToPortfolioCard
            key={_id}
            emoji={emoji}
            title={title}
            link={{
              pathname: linkForCollegeSuccessItem({type: collegeSuccessItemType, _id}),
              state: {skipScrolling: true},
            }}
          />
        );
      })}
    </Carousel>
  );
};

export default CarouselDisplay;
